// extracted by mini-css-extract-plugin
export var header = "left-header-text-module--header--VTSw7";
export var text = "left-header-text-module--text--lYnxD";
export var wrapper = "left-header-text-module--wrapper--JHT2p";